import { render, staticRenderFns } from "./EvaluationSearch.vue?vue&type=template&id=70595731&scoped=true"
import script from "./EvaluationSearch.vue?vue&type=script&lang=ts"
export * from "./EvaluationSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70595731",
  null
  
)

export default component.exports